module.exports = __webpack_public_path__ + "static/img/user.1784015206260.png";